<template>
  <div id="meet-the-team">
    <section id="about-us">
      <div class="py-12"></div>

      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3">
          {{ $i18n.t("headings.meetTheTeam") }}
        </h2>

        <v-responsive class="mx-auto mb-8" width="56">
          <v-divider></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-row class="pt-6" justify="center">
          <v-col cols="12" md="4">
            <v-avatar class="elevation-12 mb-12" size="240">
              <v-img
                :src="members[$vuetify.breakpoint.smAndDown ? 1 : 0].avatar"
              ></v-img>
            </v-avatar>
            <h2 class="font-weight-bold">
              {{ members[$vuetify.breakpoint.smAndDown ? 1 : 0].name }}
            </h2>
            {{ members[$vuetify.breakpoint.smAndDown ? 1 : 0].role }}
          </v-col>
          <v-col cols="12" md="4">
            <v-avatar class="elevation-12 mb-12" size="240">
              <v-img
                :src="members[$vuetify.breakpoint.smAndDown ? 0 : 1].avatar"
              ></v-img>
            </v-avatar>
            <h2 class="font-weight-bold">
              {{ members[$vuetify.breakpoint.smAndDown ? 0 : 1].name }}
            </h2>
            {{ members[$vuetify.breakpoint.smAndDown ? 0 : 1].role }}
          </v-col>

          <v-col
            v-for="member in members.slice(2)"
            :key="member.name"
            cols="12"
            md="4"
          >
            <v-avatar class="elevation-12 mb-12" size="240">
              <v-img :src="member.avatar"></v-img>
            </v-avatar>
            <h2 class="font-weight-bold">{{ member.name }}</h2>
            {{ member.role }}
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </section>
  </div>
</template>

<script lang="ts">
export default {
  name: "MeetTheTeamView",
  data: () => ({
        members: [
      {
        avatar: require("@/assets/team/2025-08-19/Natasha Coetzee.webp"),
        name: "Natasha Coetzee",
        role: "Head of Operations",
      },
      {
        avatar: require("@/assets/team/2025-08-19/DSCF2940.webp"),
        name: "Anri Dunckley",
        role: "Founder & Owner",
      },
      {
        avatar: require("@/assets/team/2026-10-19/Jané Bezuidenhout.webp"),
        name: "Jané Bezuidenhout",
        role: "Office & Production Manager",
      },
      {
        avatar: require("@/assets/team/2026-10-19/Elske Jonker.webp"),
        name: "Elske Jonker",
        role: "Financial Officer",
      },
      {
        avatar: require("@/assets/team/2026-10-19/Venita Joubert.webp"),
        name: "Venita Joubert",
        role: "Language Lead",
      },
      {
        avatar: require("@/assets/team/2025-08-19/Charlise Olckers.webp"),
        name: "Charlise Cooper",
        role: "Marketing Coordinator",
      },
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-2.webp"),
        name: "Nize Viveiros",
        role: "Quality Controller Foundation Phase",
      },
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-2nd group-1.webp"),
        name: "Anine Botha",
        role: "Quality Controller Intermediate Phase",
      },
      {
        avatar: require("@/assets/team/2026-10-19/Nicole Meyer.webp"),
        name: "Nicole Meyer",
        role: "Mathematics Quality Controller",
      },
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-4.webp"),
        name: "Marina Saayman",
        role: "Administrative Assistant",
      },
      {
        avatar: require("@/assets/team/2026-10-19/Marijke Hamann.webp"),
        name: "Marijke Hamann",
        role: "Administrative Assistant",
      },
      {
        avatar: require("@/assets/team/2026-10-19/Bianca Koorts.webp"),
        name: "Bianca Koorts",
        role: "Administrative Assistant",
      },
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-2nd group-3.webp"),
        name: "Johan Du Preez",
        role: "Full Stack Developer",
      },
      {
        avatar: require("@/assets/team/2025-01-31/Juff-Anri-2nd group-2.webp"),
        name: "Christo Du Preez",
        role: "Lead Developer",
      },
    ],
  }),
};
</script>
